/* eslint-disable react/no-did-update-set-state */
import PropTypes from 'prop-types';
import {DISPLAY_TYPES} from 'cl-form/FormSections/consts';
import React, {PureComponent} from 'react';
import Toggle from 'material-ui/Toggle';
import {DELETE_TYPES} from '../consts';
import _ from 'lodash';
import {
  getUpdatedFieldValue,
  getDefaultProps,
  getErrorTexts,
  isFieldEmpty,
  isFieldEqual,
  isDirtyField,
} from '../ebayListingSelectors';
import {
  updateFieldToRevise,
  updateFieldToDelete,
  updateBlurredField,
} from 'MyAccount/ViewDesigns/redux/modules/ebayListing';
import {FIELD_WIDTH} from '../consts';
import elementTypes from './elementTypes';
import {setRef} from './scrollToFieldUtils';
import Note from '../Continers/Note';
import {getOriginalValues} from 'MyAccount/Listings/EbayListing/ebayListingSelectors';
import connectWithRouter from 'shared/components/redux/connectWithRouter';
import TooltipWrapper from 'shared/components/TooltipWrapper';
import {stringToDashed} from 'cl-automation-utils';

function getValueProps(state, fieldName) {
  const originalValue = getOriginalValues(state)[fieldName];
  const value = getUpdatedFieldValue(state, fieldName);
  return {
    value,
    originalValue,
  };
}

function getMultiValueProps(state, fieldNames) {
  const valueProps = _.mapValues(_.mapKeys(fieldNames), fieldName => getValueProps(state, fieldName));
  return _.mapValues(valueProps[fieldNames[0]], (x, valuesPropertyName) => _.mapValues(valueProps, valuesPropertyName));
}

export function getErrorText(state, fieldNames) {
  const dirty = _.some(fieldNames, fieldName => isDirtyField(state, fieldName));
  const wasBlurred = _.some(fieldNames, fieldName => state.ebayListing.blurredFields[fieldName]);
  const saveAndUpdateClicked = state.ebayListing.saveAndUpdateClicked;
  const showError = saveAndUpdateClicked || wasBlurred || dirty;
  return showError
    ? getErrorTexts(state)[_.first(fieldNames, fieldName => getErrorTexts(state)[fieldName])]
    : undefined;
}

@connectWithRouter(
  (state, ownProps) => {
    let {fieldName} = ownProps;
    const {multiValue} = ownProps;
    let fieldNames;
    const multiField = _.isArray(fieldName);
    if (multiField) {
      fieldNames = fieldName;
      fieldName = fieldNames[0];
    } else {
      fieldNames = [fieldName];
    }
    const valueProps =
      multiField && multiValue ? getMultiValueProps(state, fieldNames) : getValueProps(state, fieldName);
    const defaultProps = getDefaultProps(state)[fieldName];
    return {
      parentValue: getUpdatedFieldValue(state, defaultProps.parentName),
      errorText: getErrorText(state, fieldNames),
      multiField,
      ...defaultProps,
      ...valueProps,
    };
  },
  {onChange: updateFieldToRevise, onFieldDelete: updateFieldToDelete, updateBlurredField}
)
export default class ListerField extends PureComponent {
  state = {};

  getValueForRender(value) {
    const {displayType} = this.props;
    if (_.isArray(value)) {
      switch (displayType) {
        case DISPLAY_TYPES.FREE_TEXT:
        case DISPLAY_TYPES.SINGLE_SELECT:
          return value[0];
        default:
          break;
      }
    }
    return value;
  }

  getValueForStore(value) {
    const {displayType} = this.props;
    if (_.isArray(this.props.value) && !_.isArray(value)) {
      switch (displayType) {
        case DISPLAY_TYPES.FREE_TEXT:
        case DISPLAY_TYPES.SINGLE_SELECT:
          return isFieldEmpty(value, this.props) ? null : [value];
        default:
          break;
      }
    }
    return value;
  }

  getWidth() {
    const {width, displayType} = this.props;
    if (width) {
      return width;
    }
    return elementTypes[displayType].defaultProps && elementTypes[displayType].defaultProps.width;
  }

  onChange = newValue => {
    const {value, fieldName, onChange, originalValue, multiValue} = this.props;
    if (
      fieldName &&
      !isFieldEqual(
        multiValue ? newValue[fieldName[0]] : newValue,
        multiValue ? value[fieldName[0]] : value,
        this.props
      )
    ) {
      onChange(fieldName, this.getValueForStore(newValue), this.props, originalValue);
    }
  };

  renderField() {
    const {
      required,
      implicitOptional,
      displayType,
      onFieldDelete,
      multiField,
      disabledTooltip,
      disabled,
      hideLabelInLister,
    } = this.props;
    let {fieldName, id} = this.props;
    const {value} = this.state;
    let {floatingLabelText} = this.props;
    if (hideLabelInLister) {
      floatingLabelText = undefined;
    }
    if (floatingLabelText && !required && !implicitOptional) {
      floatingLabelText += ' (optional)';
    }
    if (multiField) {
      fieldName = fieldName[0];
    }
    const idSource = floatingLabelText ? floatingLabelText.replace(' (optional)', '').toLowerCase() : fieldName;
    const idPrefix = id ? id : 'cla-field';
    id = `${idPrefix}-${stringToDashed(idSource)}`;
    const fieldProps = {
      ...this.props,
      key: 'field',
      onChange: this.onChange,
      onFieldDelete: onFieldDelete.bind(null, fieldName),
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      floatingLabelText,
      fieldName,
      id,
      ref: setRef.bind(null, fieldName),
    };
    if (value !== undefined) {
      fieldProps.value = this.getValueForRender(value);
    }
    const content = React.createElement(elementTypes[displayType], fieldProps);
    if (disabled && disabledTooltip) {
      return (
        <TooltipWrapper tooltip={disabledTooltip ? disabledTooltip : ''} popoverType="grey" enterDelay={200}>
          {content}
        </TooltipWrapper>
      );
    }
    return content;
  }

  renderDelete() {
    const {deleteType, value, fieldName, onFieldDelete} = this.props;
    switch (deleteType) {
      case DELETE_TYPES.TOGGLE:
        return <Toggle key="delete" defaultToggled={!!value} onToggle={() => onFieldDelete(fieldName)} />;
      case DELETE_TYPES.BUTTON:
        return null;
      default:
        return null;
    }
  }

  renderInstructions() {
    const {instructions} = this.props;
    if (instructions) {
      return (
        <div key="instructions" style={{whiteSpace: 'nowrap', marginRight: 10}}>
          {instructions}
        </div>
      );
    }
  }

  handleBlur = () => {
    const {multiField, updateBlurredField} = this.props;
    let {fieldName} = this.props;
    if (multiField) {
      fieldName = fieldName[0];
    }
    updateBlurredField(fieldName);
  };

  render() {
    const {noWrap, notSupported, notSupportedMessage} = this.props;
    let {style} = this.props;
    if (notSupported) {
      return notSupportedMessage ? <Note>{notSupportedMessage}</Note> : null;
    }
    const field = this.renderField();
    if (noWrap) {
      return field;
    }
    const deleteOption = this.renderDelete();
    const instructions = this.renderInstructions();

    style = {
      ...style,
      display: 'flex',
      alignItems: 'baseline',
    };
    if (this.getWidth() === FIELD_WIDTH.FULL) {
      style.width = FIELD_WIDTH.FULL;
    }
    return (
      <div style={style}>
        {instructions}
        {field}
        {deleteOption}
      </div>
    );
  }
}

ListerField.propTypes = {
  displayType: PropTypes.oneOf(_.values(DISPLAY_TYPES)),
  deleteType: PropTypes.oneOf(_.values(DELETE_TYPES)),
  fieldName: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  fieldLabel: PropTypes.string,
  floatingLabelText: PropTypes.string,
  textEditorProps: PropTypes.object,
  feesMayApply: PropTypes.bool,
  orderBy: PropTypes.shape({
    iteratees: PropTypes.array,
    orders: PropTypes.array,
  }),
  zeroShown: PropTypes.bool, // some numeric fields should show 0 and some should stay empty when the value is 0
  instructions: PropTypes.string,
  width: PropTypes.oneOf(_.values(FIELD_WIDTH)),
  implicitOptional: PropTypes.bool,
  notSupported: PropTypes.bool, // not supported for current category will not be rendered
  multiValue: PropTypes.bool, // indicates composed filed with multi value update, fieldName must be an array in that case
  noWrap: PropTypes.bool,
  unit: PropTypes.string,
  disabled: PropTypes.bool,
};

ListerField.defaultProps = {
  feesMayApply: false,
  zeroShown: false,
  errorStyle: {position: 'absolute', bottom: -8},
  clearable: true,
};
